import { ROUTES } from "@/constants/routes";

export function safeNext(search) {
  const next = new URLSearchParams(search).get("next");
  if (!next || !next.startsWith("/") || next.startsWith("//")) return null;
  return next;
}

export const loginWithNext = (path) => `${ROUTES.login}?next=${encodeURIComponent(path)}`;
